export default __webpack_public_path__ + "static/media/mobile.f4e9e470.jpg";